import React from 'react';
import Text from '@ingka/text';
import Button from '@ingka/button';
import membershipCard from '@ingka/ssr-icon/paths/membership-card';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import colors from '../styles/colors';

const LoginPromptContainer = styled.div`
  border: 1px solid ${colors.neutral.grey500};
  padding: 2rem;
  border-radius: 4px;
  max-width: 600px;
  margin: 1rem 0 2rem 0;
`;

const StyledPromptTitle = styled(Text)`
  &&& {
    margin-top: 0;
  }
`;

const StyledPromptText = styled(Text)`
  &&& {
    margin-bottom: 2rem;
    display: block;

    & > span {
      display: inline;
      white-space: normal;
    }
  }
`;

export interface LoginPromptCardProps {
  linkTo: string;
  textWithPrice?: React.ReactNode;
  dataCy?: string;
}

const LoginPromptCard: React.FC<LoginPromptCardProps> = ({
  linkTo,
  textWithPrice,
  dataCy = 'login-button',
}) => {
  const { t } = useTranslation();

  return (
    <LoginPromptContainer>
      <StyledPromptTitle tagName="h3" textStyle="Heading.M">
        {t('pages.start.loginPromptCard.title')}
      </StyledPromptTitle>
      <StyledPromptText tagName="p" textStyle="Body.L">
        {textWithPrice ? textWithPrice : t('pages.start.loginPromptCard.text')}
      </StyledPromptText>
      <Button
        type="primary"
        size="small"
        text={t('pages.start.loginPromptCard.buttonText')}
        ssrIcon={membershipCard}
        iconPosition="leading"
        href={linkTo}
        data-cy={dataCy}
        aria-label={t('pages.start.loginPromptCard.ariaLabelButton')}
      />
    </LoginPromptContainer>
  );
};

export default LoginPromptCard;
